<template>
  <div class="login-page">
    <div class="ui form" style="min-width:300px;">
      <h1 class="ui header">Sign in</h1>
      <div class="field">
        <div class="ui left icon input">
          <input type="text" v-model="email" placeholder="******@gmail.com" maxlength="100">
          <i class="mail icon"></i>
        </div>
      </div>
      <div class="field">
        <div class="flex">
          <div class="ui left icon input">
            <input type="password" v-model="verificationCode" maxlength="50" placeholder="Verification code">
            <i class="lock icon"></i>
          </div>
          <div class="ui instagram button no-shrink" style="margin-left:0.25em;margin-right:0;" @click="sendCode" v-show="!waiting">Send</div>
          <div class="ui instagram button no-shrink disabled" style="margin-left:0.25em;margin-right:0;" v-show="waiting">{{seconds}}s</div>
        </div>
      </div>
      <div class="field">
        <div class="ui primary button fluid" :class="{disabled:!isValidForm}" @click="login">Log in</div>
      </div>
    </div>
  </div>
</template>

<script>
import {genAuthCodeFetch,loginFetch} from "../http/api"
import {MyStorage} from "@/js/utils";

export default {
  name: "LoginView",
  data() {
    return {
      email: "",
      verificationCode: "",
      waiting:false,
      seconds:0
    };
  },
  computed: {
    isValidForm() {
      return this.email && this.verificationCode;
    },
  },
  mounted(){
    document.querySelector('.login-page').addEventListener('touchmove', function(event) {
      event.preventDefault();
    }, { passive: false });
  },
  methods: {
    async sendCode() {
      try {
        this.checkEmail();
      } catch (error) {
        this.$toast.show(error.message)
        return;
      }
      this.$loading.show();
      const result = await genAuthCodeFetch({username:this.email})
      if(result){
        this.$loading.hide();
        this.$toast.show(result.message)
        this.countdown();
      }
    },
    countdown(){
      this.waiting = true;
      this.seconds = 60;
      const timer = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          clearInterval(timer);
          this.waiting = false;
        }
      }, 1000);
    },
    checkEmail(){
      if(!this.email){
        throw new Error("Email cannot be empty")
      }
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // if(!emailRegex.test(this.email)){
      //   throw new Error("Email format error")
      // }
    },
    async login() {
      const res = await loginFetch({username:this.email,password:this.verificationCode})
      if(res && res.data){
        const jsonData = JSON.parse(res.data);
        MyStorage.setItem("userToken",jsonData.password);
        MyStorage.setItem("userName",jsonData.username);
        MyStorage.setItem("userLevel",jsonData.levelEnum);
        MyStorage.setItem("userLv",jsonData.level);
        this.$toast.show(res.message); //登录成功
        this.$store.dispatch('updateLoggedIn', true);
        this.$nextTick(()=>{
          this.$router.push({path:"/"})
        })
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
